import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 tenant_delete_promotion_message_setting: { message: "idle" },
};

export const tenant_delete_promotion_message_setting_Slice = createSlice({
 name: "tenant_delete_promotion_message_setting",
 initialState,
 reducers: {
  success_tenant_delete_promotion_message_setting: (state, action) => {
   state.tenant_delete_promotion_message_setting = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_tenant_delete_promotion_message_setting: (state, action) => {
   state.tenant_delete_promotion_message_setting = { status: app_consts.FAIL, message: action.payload };
  },
  reset_tenant_delete_promotion_message_setting: (state) => {
   state.tenant_delete_promotion_message_setting = { status: app_consts.IDLE };
  },
  loading_tenant_delete_promotion_message_setting: (state) => {
   state.tenant_delete_promotion_message_setting = { status: app_consts.LOADING };
  },
 }
});

export const { success_tenant_delete_promotion_message_setting, fail_tenant_delete_promotion_message_setting, reset_tenant_delete_promotion_message_setting, loading_tenant_delete_promotion_message_setting } = tenant_delete_promotion_message_setting_Slice.actions;

export default tenant_delete_promotion_message_setting_Slice.reducer;